/**
 * Install the Node globals the frozen `@fume/core` expects, before any core
 * code runs. Imported FIRST in main.tsx so ordering is guaranteed.
 *
 * `@fume/core` references the `Buffer` global (never imported) in its hkdf /
 * key-schedule / manifest / receipt / sas paths. We back it with the standard
 * `buffer` browser polyfill (a real Uint8Array subclass with `writeBigUInt64BE`,
 * `toString('hex')`, etc.). NOTHING here persists to storage — this only wires
 * an in-memory byte helper.
 */
import { Buffer as BufferPolyfill } from 'buffer';

const globals = globalThis as typeof globalThis & { Buffer?: unknown };
if (typeof globals.Buffer === 'undefined') {
  globals.Buffer = BufferPolyfill;
}

export {};
